(angular => {
  "use strict";

  angular.module("Pages").controller("Pages.voucherCtrl", [
    "Loader",
    "ParticipantService",
    "VoucherService",
    VoucherCtrl
  ]);

  function VoucherCtrl(loader, participantService, voucherService) {

    loader.add(participantService.current())
      .then(participant => {
        this.hasVoucher = participant.has_voucher;

        this.banner = participant.event.assets
          .filter(a => a.type === "banner")
          .map(a => a.path)[0];
    });

    this.getVoucher = () => {
      return voucherService.getVoucher();
    };
  }

})(angular);
